import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { cnpjMask, cepMask, foneMask } from '../../common/Mask'
import Loading from '../../common/Loading'

class Empresa extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            filtros: [],
            isListagem:true,
            isEdicao: false,
            isLoading: false,
            id:'',
            cnpj:'',
            razao:'',
            fantasia:'',
            cep:'',
            endereco:'',
            numero:'',
            complemento:'',
            uf:'',
            ufs:[],
            ufDefault:[],
            cidade:'',
            bairro:'',
            fone:'',
            email:'',
            botwhatsapp:''
        }
        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.handleFiltroGrid = this.handleFiltroGrid.bind(this);
    }

    async Loading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaEmpresa        = permissoes.data.filter(function(value){ return value.idmenu  == 2  })
        if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        this.setState({isLoading: true })

        await api.get('/api/empresa', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState( { items : response.data, filtros: response.data,isLoading: false } );
        })
    }

    add = async () => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token     = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaEmpresa        = permissoes.data.filter(function(value){ return value.idmenu  == 2  })
        if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

        this.setState({isLoading: true })

        const ufs = [
            {label:'AC', value:'AC'},
            {label:'AL', value:'AL'},
            {label:'AP', value:'AP'},
            {label:'AM', value:'AM'},
            {label:'BA', value:'BA'},
            {label:'CE', value:'CE'},
            {label:'DF', value:'DF'},
            {label:'GO', value:'GO'},
            {label:'MA', value:'MA'},
            {label:'MT', value:'MT'},
            {label:'MG', value:'MG'},
            {label:'PA', value:'PA'},
            {label:'PB', value:'PB'},
            {label:'PR', value:'PR'},
            {label:'PE', value:'PE'},
            {label:'PI', value:'PI'},
            {label:'RJ', value:'RJ'},
            {label:'RN', value:'RN'},
            {label:'RS', value:'RS'},
            {label:'RO', value:'RO'},
            {label:'SC', value:'SC'},
            {label:'SP', value:'SP'},
            {label:'SE', value:'SE'},
            {label:'TO', value:'TO'},

        ]
     
        this.setState({
            isListagem: false, 
            isEdicao:true,
            isLoading: false,
            id:'',
            cnpj:'',
            razao:'',
            fantasia:'',
            cep:'',
            endereco:'',
            numero:'',
            complemento:'',
            uf:'',
            ufs:ufs,
            ufDefault:[],
            cidade:'',
            bairro:'',
            fone:'',
            email:'',
            botwhatsapp:''
            
        })

    }

    edit = async( id ) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token     = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaEmpresa        = permissoes.data.filter(function(value){ return value.idmenu  == 2  })
        if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.')

        this.setState({isLoading: true })

        try {

            const ufs = [
                {label:'AC', value:'AC'},
                {label:'AL', value:'AL'},
                {label:'AP', value:'AP'},
                {label:'AM', value:'AM'},
                {label:'BA', value:'BA'},
                {label:'CE', value:'CE'},
                {label:'DF', value:'DF'},
                {label:'GO', value:'GO'},
                {label:'MA', value:'MA'},
                {label:'MT', value:'MT'},
                {label:'MG', value:'MG'},
                {label:'PA', value:'PA'},
                {label:'PB', value:'PB'},
                {label:'PR', value:'PR'},
                {label:'PE', value:'PE'},
                {label:'PI', value:'PI'},
                {label:'RJ', value:'RJ'},
                {label:'RN', value:'RN'},
                {label:'RS', value:'RS'},
                {label:'RO', value:'RO'},
                {label:'SC', value:'SC'},
                {label:'SP', value:'SP'},
                {label:'SE', value:'SE'},
                {label:'TO', value:'TO'},
    
            ]
       
            const token    = sessionStorage.getItem('token');
       
            await api.get(`/api/empresa/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(async response => {
                const ufDefault = response.data.uf ? ufs.filter( item => item.value && item.value.toLowerCase().includes(response.data.uf.toLowerCase())) : {};
        
                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    isLoading: false,
                    id:response.data.id,
                    cnpj:response.data.cnpj,
                    razao:response.data.razao,
                    fantasia:response.data.fantasia,
                    cep:response.data.cep,
                    endereco:response.data.endereco,
                    numero:response.data.numero,
                    complemento:response.data.complemento,
                    uf:response.data.uf,
                    ufs:ufs,
                    ufDefault:ufDefault,
                    cidade:response.data.cidade,
                    bairro:response.data.bairro,
                    fone:response.data.fone,
                    email:response.data.email,
                    botwhatsapp:response.data.botwhatsapp
                })
            })
        } catch (error) {
            toast.error('Ocorreu um erro inesperado. Tente mais tarde.')
        }
    }

    cancel = (item) => {
        this.setState({isLoading: true })

        const token    = sessionStorage.getItem('token');
       
        api.get('/api/empresa', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                isLoading: false,
                id:'',
                cnpj:'',
                razao:'',
                fantasia:'',
                cep:'',
                endereco:'',
                numero:'',
                complemento:'',
                uf:'',
                ufs:[],
                ufDefault:[],
                cidade:'',
                bairro:'',
                fone:'',
                email:'',
                botwhatsapp:'',
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const {id, cnpj, razao, fantasia, cep, endereco, numero, complemento, uf, cidade, bairro, fone, email, botwhatsapp } = this.state
        
        const grupo     = sessionStorage.getItem('grupo');       
        const token     = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaEmpresa        = permissoes.data.filter(function(value){ return value.idmenu  == 2  })
       
        
        try {
            
            if ( id ) {

                if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.')

                this.setState({isLoading: true })

                await api.put(`/api/empresa/${id}`,{ cnpj, razao, fantasia, cep, endereco, numero, complemento, uf, cidade, bairro, fone, email, botwhatsapp }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/empresa', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            isLoading: false,
                            id:'',
                            cnpj:'',
                            razao:'',
                            fantasia:'',
                            cep:'',
                            endereco:'',
                            numero:'',
                            complemento:'',
                            uf:'',
                            ufs:[],
                            ufDefault:[],
                            cidade:'',
                            bairro:'',
                            fone:'',
                            email:'',
                            botwhatsapp:'',
                            items : response.data
                        });
                    })
                }).catch(error => {
                    this.setState({isLoading: false })
                    toast.error("Ocorreu um erro inesperado.")
                }) 
                
            } else {
                if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.')

                this.setState({isLoading: true })

                await api.post('/api/empresa',{ id, cnpj, razao, fantasia, cep, endereco, numero, complemento, uf, cidade, bairro, fone, email, botwhatsapp }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
            
                    api.get('/api/empresa', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            isLoading: false,
                            id:'',
                            cnpj:'',
                            razao:'',
                            fantasia:'',
                            cep:'',
                            endereco:'',
                            numero:'',
                            complemento:'',
                            uf:'',
                            ufs:[],
                            ufDefault:[],
                            cidade:'',
                            bairro:'',
                            fone:'',
                            email:'',
                            botwhatsapp:'',
                            items : response.data
                
                        });
                    })
                })
            }
        } catch (error) {
            toast.error(`Ocorreu um erro inesperado. Tente novamente. ${error}`)            
        }        
    }

    delete = async (id) => {
        
        const grupo     = sessionStorage.getItem('grupo');       
        const token     = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaEmpresa        = permissoes.data.filter(function(value){ return value.idmenu  == 2  })
        if( empresaEmpresa.length > 0 && empresaEmpresa[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.')

        try {

            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                this.setState({isLoading: true })

                await api.delete(`/api/empresa/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/empresa', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data, isLoading: false } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }

    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/empresa', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                id:'',
                cnpj:'',
                razao:'',
                fantasia:'',
                cep:'',
                endereco:'',
                numero:'',
                complemento:'',
                uf:'',
                ufs:[],
                ufDefault:[],
                cidade:'',
                bairro:'',
                fone:'',
                email:'',
                botwhatsapp:'',
                items : response.data    
            })
        })
    } 
    
    handleFiltroGrid = async (filterText) => {
        const { filtros, items } = this.state;
        this.Loading(true);
        const filtragem =
          filterText.length > 0
            ? items.filter((item) =>
                (
                  item.cnpj +
                  "" +
                  item.razao +
                  "" +
                  item.email 
                )
                  .toLowerCase()
                  .includes(filterText.toLowerCase())
              )
            : filtros;
        this.setState({ items: filtragem, filterText: filterText });
    
        this.Loading(false);
      };
   
    render() {

        const {items,isListagem, isEdicao} = this.state;
        const subHeaderComponentMemo = (
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar"
                  onChange={(e) => this.handleFiltroGrid(e.target.value)}
                />
                <div class="input-group-append">
                  <div class="btn btn-primary">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
          );

       
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO EMPRESA</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Lista"
                                                    columns={[
                                                        
                                                        {
                                                            name: 'CNPJ',
                                                            selector: 'cnpj',
                                                            sortable: true,
                                                        },
                                                        {
                                                          name: 'RAZÃO',
                                                          selector: 'razao',
                                                          sortable: true,
                                                        },
                                                        {
                                                            name: 'E-MAIL',
                                                            selector: 'email',
                                                            sortable: true,
                                                        },
                                                        {
                                                          name: 'Editar',
                                                          selector: 'Editar',
                                                          cell: row =>   <div class="btn-group">
                                                                            <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                                                            <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                                                                        
                                                                        </div>,
                                                          button: true,
                                                        }
                                                    ]}
                                                    data={items}
                                                    pagination
                                                    subHeader
                                                    subHeaderComponent={subHeaderComponentMemo}
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                            
                                            </div>
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div class="col-sm-2">
                                                        <div className="form-group">
                                                            <label>ID</label>
                                                            <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-2">
                                                            <div className="form-group">
                                                                <label>Cnpj</label>
                                                                <input type="text" className="form-control" name="cnpj" placeholder="CNPJ da pessoa" maxLength="18" value={ this.state.cnpj} onChange={ e => this.setState({ cnpj: cnpjMask( e.target.value ) })} />
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-5">
                                                            <div className="form-group">
                                                                <label>Razão</label>
                                                                <input type="text" className="form-control" name="razao" placeholder="Razão do Registro" value={ this.state.razao } onChange={ e => this.setState({ razao: e.target.value})} required/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div className="form-group">
                                                                <label>Fantasia</label>
                                                                <input type="text" className="form-control" name="fantaisa" placeholder="Fantasia do Registro" value={ this.state.fantasia } onChange={ e => this.setState({ fantasia: e.target.value})} required/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div className="form-group">
                                                                <label>Whathsapp</label>
                                                                <input type="text" className="form-control" name="botwhatsapp" placeholder="Informe o whatsapp code" value={ this.state.botwhatsapp } onChange={ e => this.setState({ botwhatsapp: e.target.value})}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-2">
                                                            <div class="form-group">
                                                                <label>Cep</label>
                                                                <input type="text" class="form-control" value={ this.state.cep } onChange={e => this.setState({cep: cepMask(e.target.value)})} placeholder="Cep do registro"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-8">
                                                            <div class="form-group">
                                                                <label>Endereço</label>
                                                                <input type="text" class="form-control" value={ this.state.endereco } onChange={ e => this.setState({ endereco: e.target.value })} placeholder="Endereço do registro"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div class="form-group">
                                                                <label>Número</label>
                                                                <input type="text" class="form-control" value={ this.state.numero } onChange={ e => this.setState({ numero: e.target.value })} placeholder="Número do registro"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="form-group">
                                                                <label>Complemento</label>
                                                                <input type="text" class="form-control" value={ this.state.complemento } onChange={ e => this.setState({ complemento: e.target.value })} placeholder="Complemento do registro"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-2">
                                                            <div class="form-group">
                                                                <label>Uf</label>
                                                                <Select
                                                                    id="uf"
                                                                    placeholder="Selecione" 
                                                                    isSearchable="true"
                                                                    isOptionSelected
                                                                    value={this.state.ufDefault}
                                                                    options={ this.state.ufs } 
                                                                    onChange={ e => this.setState({uf: e.value, ufDefault:[{label: e.label, value: e.value }] })}
                                                                />

                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div class="form-group">
                                                                <label>Cidade</label>
                                                                <input type="text" class="form-control" value={ this.state.cidade } onChange={e => this.setState({ cidade:e.target.value })} placeholder="Cidade do registro"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2">
                                                            <div class="form-group">
                                                                <label>Bairro</label>
                                                                <input type="text" class="form-control" value={ this.state.bairro } onChange={e => this.setState({ bairro:e.target.value })} placeholder="Cidade do registro"/>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <label>E-mail</label>
                                                                <input type="email" class="form-control" value={ this.state.email } onChange={e => this.setState({ email:e.target.value })} placeholder="E-mail do registro"/>
                                                            </div>
                                                        </div>
                                                    
                                                        
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <label>Fone</label>
                                                                <input type="text" class="form-control" value={ this.state.fone } onChange={e => this.setState({ fone: foneMask(e.target.value) })} placeholder="Fone do registro"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                            <Loading isCarrega={ this.state.isLoading } />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Empresa;